import { render, staticRenderFns } from "./EditSalePersonForm.vue?vue&type=template&id=bd1d0db8&"
import script from "./EditSalePersonForm.vue?vue&type=script&lang=js&"
export * from "./EditSalePersonForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports